import './index.scss'
import classNames from 'classnames'

const SkeletonLoader = (props) => {
    const className = props.className
    return (
        <div className={classNames({
            'skeleton-loader': true,
            [className]: className
        })}/>
    )
}
export default SkeletonLoader
